import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'

const DayWiseOrdersChart = ({ finalData }) => {
  const categories = finalData?.map((item) => {
    const date = new Date(item.date)
    return `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}`
  })

  const numberOfOrders = finalData?.map((item) => parseInt(item.number_of_orders))
  const totalOrdersAmount = finalData?.map((item) => item.total_orders_amount)

  const options = {
    chart: {
      type: 'column',
      height: 500,
      className: 'shadow-lg rounded-lg bg-white'
    },
    title: {
      text: '',
      style: {
        fontSize: '1.5rem',
        fontWeight: 'bold',
        fontFamily: 'inherit'
      }
    },
    xAxis: {
      categories,
      crosshair: true,
      title: {
        text: 'Date'
      }
    },
    yAxis: {
      title: {
        text: 'Number of Orders'
      },
      min: 0
    },
    tooltip: {
      shared: true,
      formatter: function () {
        let tooltip = `<b>${this.x}</b><br/>`
        this.points.forEach((point) => {
          if (point.series.name === 'Number of Orders') {
            tooltip += `${point.series.name}: <b>${point.y}</b><br/>`
          } else {
            const actualAmount = totalOrdersAmount[point.point.index]
            tooltip += `${point.series.name}: <b>$${actualAmount.toFixed(2)}</b><br/>`
          }
        })
        return tooltip
      }
    },
    series: [
      {
        name: 'Number of Orders',
        type: 'column',
        data: numberOfOrders,
        color: '#3B82F6',
        dataLabels: {
          enabled: true,
          formatter: function () {
            const amount = totalOrdersAmount[this.point.index]
            if (amount === 0) return null // Hide if 0
            return `$${amount.toFixed(2)}`
          },
          style: {
            fontWeight: 'bold',
            color: '#000'
          },
          y: -10
        }
      },
      {
        name: 'Total Orders Amount',
        type: 'line',
        data: numberOfOrders, // same x-points as Number of Orders
        color: '#10B981',
        marker: {
          symbol: 'circle',
          radius: 6,
          fillColor: '#FFFFFF',
          lineWidth: 2,
          lineColor: '#10B981'
        },
        tooltip: {
          pointFormatter: function () {
            const actualAmount = totalOrdersAmount[this.index]
            return `<span style="color:${this.color}">\u25CF</span> Total Orders Amount: <b>$${actualAmount.toFixed(
              2
            )}</b><br/>`
          }
        }
      }
    ],
    credits: {
      enabled: false
    },
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 600
          },
          chartOptions: {
            legend: {
              layout: 'horizontal',
              align: 'center',
              verticalAlign: 'bottom'
            }
          }
        }
      ]
    }
  }

  return (
    <div className="overflow-hidden rounded-lg bg-white shadow">
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  )
}

export default DayWiseOrdersChart
